import { File, FileArchive, FileAudio, FileCode, FileImage, FileSpreadsheet, FileText, FileVideo, Folder, Presentation, ScrollText } from 'lucide-react';
import type { DriveNode } from '../lib/types';

const ICONS = {
  folder: Folder, image: FileImage, pdf: ScrollText, video: FileVideo, audio: FileAudio, archive: FileArchive,
  document: FileText, spreadsheet: FileSpreadsheet, presentation: Presentation, code: FileCode, text: FileText, other: File,
} as const;

export function FileIcon({ node, size = 20 }: { node: Pick<DriveNode, 'type'>; size?: number }) {
  const Icon = ICONS[node.type] ?? File;
  return <Icon aria-hidden size={size} className={`ficon ficon--${node.type}`} />;
}
